import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix default marker icon paths (webpack strips them otherwise)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const esc = (s) => String(s || "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function WarehouseMap({ warehouses }) {
  const containerRef = useRef(null);
  const mapRef = useRef(null);
  const pinned = (warehouses || []).filter((w) => typeof w.lat === "number" && typeof w.lng === "number");
  const sig = JSON.stringify(pinned.map((p) => [p.id, p.lat, p.lng, p.item_count, p.unit_count]));

  useEffect(() => {
    if (!containerRef.current || pinned.length === 0) return undefined;
    // Guard against StrictMode double-init and any stale instance
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }
    const map = L.map(containerRef.current, { scrollWheelZoom: false }).setView([pinned[0].lat, pinned[0].lng], 5);
    mapRef.current = map;
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    }).addTo(map);
    const coords = [];
    pinned.forEach((w) => {
      const m = L.marker([w.lat, w.lng]).addTo(map);
      m.bindPopup(`<div style="font-size:13px"><b>${esc(w.name)}</b>${w.location ? `<br/><span style="color:#6b7280">${esc(w.location)}</span>` : ""}<br/>${w.item_count || 0} items · ${w.unit_count || 0} units</div>`);
      coords.push([w.lat, w.lng]);
    });
    if (coords.length === 1) map.setView(coords[0], 11);
    else map.fitBounds(coords, { padding: [40, 40], maxZoom: 12 });
    setTimeout(() => map.invalidateSize(), 200);
    return () => { map.remove(); mapRef.current = null; };
  }, [sig]); // eslint-disable-line react-hooks/exhaustive-deps

  if (pinned.length === 0) {
    return (
      <div className="border border-border rounded-md bg-muted/30 p-8 text-center text-sm text-muted-foreground" data-testid="warehouse-map-empty">
        No warehouses have a mappable location yet. Add a location (e.g. "Nasr City, Cairo, Egypt") to a warehouse to pin it here.
      </div>
    );
  }
  return <div ref={containerRef} data-testid="warehouse-map" className="border border-border rounded-md overflow-hidden" style={{ height: 380, width: "100%", position: "relative", zIndex: 0, isolation: "isolate" }} />;
}
